import { CustomThemeContext, type CustomThemeContextData } from "@/contexts/CustomThemeContext";
import { useContext } from "react";

export function useCustomTheme(): CustomThemeContextData {
  return useContext(CustomThemeContext);
}
